import { Component, OnInit, ViewChild, AfterViewInit, TemplateRef, ChangeDetectorRef } from '@angular/core';
import { ManagePackagesDataSource } from '../../../../core/packages/_data-sources/manage-packages.datasource';
import { MatPaginator, MatSort, MatDialog, MatDialogConfig, MatSnackBar } from '@angular/material';
import { PackagesHttpService } from '../../../../core/packages';
import { merge } from 'rxjs';
import { tap } from 'rxjs/operators';
import { Cache } from 'aws-amplify';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { EditFileDialogComponent } from '../edit-file-dialog/edit-file-dialog.component';
import { Observable } from 'rxjs';
import { MixpanelService } from '../../../../services/mixpanel.service';
import { SelectOption } from '../../../partials/content/general/searchable-select/searchable-select.component';

@Component({
  selector: 'kt-bundle-spec',
  templateUrl: './bundle-spec.component.html',
  styleUrls: ['./bundle-spec.component.scss']
})
export class BundleSpecComponent implements OnInit {

	displayedColumns = ['file_version', 'file_desc', 'file_name', 'actions'];

	dataSource: ManagePackagesDataSource;

	typeSelected: string | number | null = null;
	modeSelected: string | number | null = null;

	typeOptions: SelectOption[] = [
		{ value: 'menu', label: 'Menu' },
		{ value: 'aux', label: 'VMC' }
	];
	modeOptions: SelectOption[] = [
		{ value: 'engg', label: 'Engineering Review' },
		{ value: 'curr', label: 'Current' },
		{ value: 'arch', label: 'Archived' }
	];
	uiVersionOptions: SelectOption[] = [];

	bundSpec;

	private dialogConfig = new MatDialogConfig();

	qParams = {};

	@ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;

	@ViewChild(MatSort, {static: false}) sort: MatSort;

	@ViewChild('successTemp', {static: true})
	private msgTempRef: TemplateRef<any>;

	types = [
		// {text: 'UI', value: 'ui'},
		{text: 'Menu', value: 'menu'},
		{text: 'VMC', value: 'aux'}
	];

	modes = [
		{text: 'Engineering Review', value: 'engg'},
		{text: 'Current', value: 'curr'},
		{text: 'Archived', value: 'arch'}
	];

	availableColors = [
		{ name: 'v0.1.0', color: '' },
		{ name: 'v0.1.1', color: 'primary' },
		{ name: 'v0.1.2', color: 'accent' },
		{ name: 'v0.1.3', color: 'warn' }
	];

	availableVersions = [];

	uiVersions: string[] = [];
	selectedUI: string | number | null = null;
  	tableData: any[][] = [];

  constructor(private http: PackagesHttpService,
				public dialog: MatDialog,
				private cdr: ChangeDetectorRef,
				private modalService: NgbModal,
				private _snackBar: MatSnackBar,
				private mixpanelService: MixpanelService) { }

  ngOnInit() {
	  this.dataSource = new ManagePackagesDataSource(this.http);
	  this.qParams = {
		noPerPg: this.paginator.pageSize || 5,
		pgNo: this.paginator.pageIndex || 0,
		sortKey: 'uploaded_at',
		sortVal: 'desc',
		optFilterKey: 'file_type',
		optFilterVal: '',
		txtFilterKey: 'file_mode',
		txtFilterVal: ''
	};

	  this.mixpanelService.track(this.mixpanelService.PAGE_VIEW);
  }

  ngAfterViewInit() {
	// this.dataSource.counter$
	// .pipe(
	// 	tap((count) => {
	// 	this.paginator.length = count;
	// 	})
	// )
	// .subscribe();

	// this.sort.sortChange.subscribe(() => this.paginator.pageIndex = 0);

	// merge(this.paginator.page, this.sort.sortChange).pipe(
	// 	tap(() => {
	// 		this.loadPackageListPage();
	// 	})
	// )
	// .subscribe();

		// this.dataSource = new ManagePackagesDataSource(this.http);
		// this.qParams = {
		//   // ... your params
		// };

		this.loadPackageListPageUI();
  }



  assign(file){
	const userAttributes = Cache.getItem('userAttr');
  	const email = userAttributes.email;
	// console.log("Email:", email);
	const uiValue = this.selectedUI || '';
	const assignObj =  {
		email: email,
		ui_cv: uiValue,
		data: file
	  };
	console.log("FILE CONSOLE",assignObj);
	this.http.assignBundleSpec(assignObj)
			.subscribe(resp => {
				this.showSnackBar('Package Assigned Successfully', 0);
				// this.loadPackageListPageUI();
				this.loadBundleSpec(this.selectedUI);
				this.cdr.detectChanges();
				setTimeout(() => {
					this._snackBar.dismiss();
				}, 2000);
			}, error => {
				this.showSnackBar('Error while assigning', 0);
			});

  }

  deleteFile(confirmTemplate: any, item: { type: string, value: any }) {
	this.modalService.open(confirmTemplate, {size: 'sm'}).result.then((result) => {
		// console.log('result', result);
		const uiValue = Array.isArray(this.selectedUI) && this.selectedUI.length > 0 ? this.selectedUI[0] : '';
		const remobj ={
			type : item.type,
			value : item.value,
			ui_cv: uiValue,
		}
		if (result === 'delete') {
			this.http.delBundleSpec(remobj)
			.subscribe(resp => {
				this.showSnackBar('Deleted Successfully', 0);
				this.loadBundleSpec(this.selectedUI);
				this.cdr.detectChanges();
				setTimeout(() => {
					this._snackBar.dismiss();
				}, 2000);
			}, error => {
				this.showSnackBar('Error while deleting', 0);
			});
		} else {
		}
	}, (reason) => {
	});
  }

  typeChanged(val: string | number | null) {
	this.typeSelected = val;
	if (val && this.modeSelected) {
		this.loadPackageListPage();
	}
  }

  modeChanged(val: string | number | null) {
	this.modeSelected = val;
	if (val && this.typeSelected) {
		this.loadPackageListPage();
	}
  }

  loadPackageListPage() {
	const typeValue = this.typeSelected || '';
	const modeValue = this.modeSelected || '';

	const params = {
		noPerPg: 50,
		pgNo: this.paginator.pageIndex || 0,
		sortKey: this.sort ? this.sort.active : 'uploaded_at',
    	sortVal: this.sort ? this.sort.direction : 'desc',
		optFilterKey: 'file_type',
		optFilterVal: typeValue,
		txtFilterKey: 'file_mode',
		txtFilterVal: modeValue
	};

	this.dataSource.loadPackageList(params);
	// console.log("Dataa:" this.dataSource)
  }


loadPackageListPageUI() {
	const params = {
	  noPerPg: this.paginator.pageSize || 5,
	  pgNo: this.paginator.pageIndex || 0,
	  sortKey: this.sort ? this.sort.active : 'uploaded_at',
    	sortVal: this.sort ? this.sort.direction : 'desc',
	  optFilterKey: 'file_type',
	  optFilterVal: 'ui'

	};

	// this.dataSource.loadPackageList(params);

	this.http.getAllUIFiles(params).subscribe(pListD => {
	  const pList = pListD.data;
	//   console.log(pList);

	  this.uiVersions = pList.payload.map(item => item.file_version);
	  this.uiVersionOptions = this.uiVersions.map(version => ({
		  value: version,
		  label: version
	  }));
	  this.cdr.detectChanges();
	});

	// this.dataSource.loadPackageListUI(params);
  }

  loadBundleSpec(ui: string | number | null) {
	const uiValue = ui || '';

	const params = {
		ui_cv: uiValue
	};

	this.http.getBundleSpec(params)
      .subscribe((data: any) => {
		// console.log('Received data:', data.data);
		if(data.data && data.data.length){
			const res = data.data[0];
			this.bundSpec = {
				ui: uiValue,
				menu: res.menu_av,
				aux: res.aux_av
			};
		}else{
			this.bundSpec = null;
		}

		this.cdr.detectChanges();

		// console.log("Result", res);

        // this.tableData = [
        //   ['UI', this.selectedUI || "NULL"],
        //   ['Menu', res.menu_av || "NULL"],
        //   ['AUX', res.aux_av || "NULL"]
        // ];
      });

	// this.dataSource.loadBundleSpec(params);

  }

  UIChanged(selectedValue: string | number | null) {
    this.selectedUI = selectedValue;
    if (selectedValue) {
      this.loadBundleSpec(selectedValue);
    }
  }



  showSnackBar(message: string, duration: number) {
	let snackRef = this._snackBar.open(message, 'close');
	if (duration > 0) {
		setTimeout(() => {
			this._snackBar.dismiss();
		}, duration);
	}

	snackRef.onAction().subscribe(() => {
		this._snackBar.dismiss();
	});
}

}
